// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2488":"da6e649e","4462":"e3943ef4","5359":"03fda812","8065":"b9ee8ae0","8861":"2fed9aa9"}[chunkId] + ".chunk.css";
};